/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Reason_BusyInputs */

const en_us2_swap_reason_busy = /** @type {(inputs: Swap_Reason_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machine taken`)
};

const pt_br2_swap_reason_busy = /** @type {(inputs: Swap_Reason_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aparelho ocupado`)
};

const es_419_swap_reason_busy = /** @type {(inputs: Swap_Reason_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máquina ocupada`)
};

const pt_pt2_swap_reason_busy = /** @type {(inputs: Swap_Reason_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máquina ocupada`)
};

const fr_fr2_swap_reason_busy = /** @type {(inputs: Swap_Reason_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machine occupée`)
};

const de_de2_swap_reason_busy = /** @type {(inputs: Swap_Reason_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerät besetzt`)
};

const it_it2_swap_reason_busy = /** @type {(inputs: Swap_Reason_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macchina occupata`)
};

/**
* | output |
* | --- |
* | "Machine taken" |
*
* @param {Swap_Reason_BusyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_reason_busy = /** @type {((inputs?: Swap_Reason_BusyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Reason_BusyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_reason_busy(inputs)
	if (locale === "es-419") return es_419_swap_reason_busy(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_reason_busy(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_reason_busy(inputs)
	if (locale === "de-DE") return de_de2_swap_reason_busy(inputs)
	if (locale === "it-IT") return it_it2_swap_reason_busy(inputs)
	return en_us2_swap_reason_busy(inputs)
});
export { swap_reason_busy as "swap.reason_busy" }